import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';

const EditorTextCell = (props: GridCustomCellProps) => {
  const handleChange = (e: InputChangeEvent) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value
      });
    }
  }

  const { dataItem } = props;
  const field = props.field || '';
  const dataValue = dataItem[field] === null ? '' : dataItem[field];

  return dataItem.inEdit
    ? <td {...props.tdProps}>
        <Input value={dataValue} onChange={handleChange} />
      </td>
    : <td {...props.tdProps} style={{ maxWidth: '1vw' }}>
        {dataValue}
      </td>
}

export default EditorTextCell;
